import React from "react";
import { IManagerProps, Manager } from "./components/manager";
import ApplicationContext, { defaults } from "./context/ApplicationContext";

import "semantic-ui-css/semantic.min.css";
import { Main } from "./components/main/Main";

const props: IManagerProps = {
  value: "",
};

function App() {
  return (
    <div>
      <ApplicationContext.Provider value={defaults}>
        <Main />
      </ApplicationContext.Provider>
    </div>
  );
}

export default App;
